import React from 'react'
import PropTypes from 'prop-types'
import Head from 'next/head'

const withMeta = (metaProps) => (Component) => {
  const WithMetaComponent = (props) => {
    const { useMeta = true, whitelabel, intl } = props

    let defaultMeta = {
      name: 'Vista Social',
      title: 'Powerful tools for social media management',
      description: 'Expertly crafted social media management tools to help you exceed your goals',
      path: '/',
      favicon: '/assets/favicon.ico?v=1',
    }
    const metaPropsTranslated = {}

    for (const key in metaProps) {
      if (typeof metaProps[key] === 'function') {
        try {
          metaPropsTranslated[key] = metaProps[key](intl)
        } catch (error) {
          console.log(error)
        }
      } else {
        metaPropsTranslated[key] = metaProps[key]
      }

      // console.log('key', key, typeof metaProps[key])
    }

    defaultMeta = { ...defaultMeta, ...metaProps, ...metaPropsTranslated, ...props.metaDynamic }

    let canonical = `${process.env.NEXT_PUBLIC_SITE_URL}${defaultMeta.path}`

    if (whitelabel) {
      defaultMeta.title = defaultMeta.title.replace('Vista Social', whitelabel.name)

      if (whitelabel.favicon_url) {
        defaultMeta.favicon = whitelabel.favicon_url
      }

      if (whitelabel.domain) {
        canonical = `https://${whitelabel.domain}${defaultMeta.path}`
      }

      if (whitelabel.logo_url) {
        defaultMeta.image = whitelabel.logo_url
      }
    }

    if (whitelabel && whitelabel.name) {
      if (!defaultMeta.title.includes(whitelabel.name)) {
        defaultMeta.title = `${defaultMeta.title} | ${whitelabel.name}`
      }

      defaultMeta.description = defaultMeta.description.replace('Vista Social', whitelabel.name)
    }

    return (
      <React.Fragment>
        {useMeta && (
          <Head>
            <title>{defaultMeta.title}</title>
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="description" content={defaultMeta.description} />
            <meta name="viewport" content="width=device-width, initial-scale=1.0,maximum-scale=1.0" />
            <meta name="title" content={defaultMeta.title} />
            <meta property="og:type" content="website" />
            <meta property="og:title" content={defaultMeta.title} />
            <meta property="og:description" content={defaultMeta.description} />
            <meta property="og:image" content={defaultMeta.image} />
            <meta property="og:url" content={canonical} />
            <meta property="fb:app_id" content={defaultMeta.fbapp} />
            <meta property="og:site_name" content={defaultMeta.name} />
            <meta property="og:image:alt" content={defaultMeta.title} />
            <link rel="image_src" href={defaultMeta.image} />
            <link rel="shortcut icon" type="image/x-icon" href={defaultMeta.favicon} />
            <link rel="canonical" href={canonical} />
          </Head>
        )}
        <Component {...props} />
      </React.Fragment>
    )
  }

  WithMetaComponent.defaultProps = {
    title: '',
    metaDynamic: {},
    useMeta: true,
    whitelabel: null,
  }

  WithMetaComponent.propTypes = {
    title: PropTypes.string,
    metaDynamic: PropTypes.object,
    useMeta: PropTypes.bool,
    whitelabel: PropTypes.object,
  }

  WithMetaComponent.getInitialProps = (context) => {
    if (Component.getInitialProps) {
      return Component.getInitialProps(context)
    } else return {}
  }
  return WithMetaComponent
}

export default withMeta
